import { render } from "./New_McrItem.vue?vue&type=template&id=3fd6b106"
import script from "./New_McrItem.vue?vue&type=script&lang=js"
export * from "./New_McrItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__